import { restRequest } from 'common-src/features/rest/actions';
import { HttpMethods } from 'common-src/features/rest/constants';

export const getPatientRestRequest = (id, params) =>
  restRequest({ uri: `members/${id}`, method: HttpMethods.Get, ...params });

export const reopenAccount = (id, statusType, params) =>
  restRequest({
    uri: `members/${id}/reopen`,
    method: HttpMethods.Put,
    body: { statusType },
    ...params,
  });

export const updatePatient = (id, body, params = {}) =>
  restRequest({
    uri: `members/${id}`,
    method: HttpMethods.Patch,
    body: { ...body },
    ...params,
  });

export const removeAlerts = (id, params) =>
  restRequest({
    uri: `members/${id}/removeAlerts`,
    method: HttpMethods.Post,
    body: {},
    ...params,
  });

export const sendScreeningLink = (id, body, params) =>
  restRequest({
    uri: `members/${id}/sendScreeningLink`,
    method: HttpMethods.Post,
    body,
    ...params,
  });

export const sendAIGuidedScreeningLink = (id, body, params) =>
  restRequest({
    uri: `members/${id}/sendAIGuidedScreeningLink`,
    method: HttpMethods.Post,
    body,
    ...params,
  });

export const createPatient = (body, params) =>
  restRequest({
    uri: 'members/create',
    method: HttpMethods.Post,
    body,
    ...params,
  });
